export default "/dist/files/rubrique_destination.07b45abf5dd8a16e46e2adb460498b64.svg";